import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgentRoutingModule } from './agent-routing.module';
import {AgentServicePageComponent} from '../../app/layout/templates/agent-service-page/agent-service-page.component';
import {AgentSearchboxComponent} from '../../app/layout/templates/agent-searchbox/agent-searchbox.component';
import {AgentPageComponent} from '../../app/layout/templates/agent-page/agent-page.component';
import {GeneralModule} from '../general/general.module';
import {ReviewItemComponent} from '../../app/layout/templates/review-item/review-item.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material';
import {NgxPhoneSelectModule} from '../ngx-phone-select/ngx-phone-select.module';
import { TextMaskModule } from 'angular2-text-mask';
import {AgentPayComponent} from "../../app/layout/templates/agent-pay/agent-pay.component";

@NgModule({
  declarations: [AgentServicePageComponent, AgentSearchboxComponent, AgentPageComponent, ReviewItemComponent, AgentPayComponent ],
  imports: [
    CommonModule,
    AgentRoutingModule,
      GeneralModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    NgxPhoneSelectModule,
    TextMaskModule
  ]
})
export class AgentModule { }
